import FormErrorMessage from 'client/components/FormErrorMessage'
import { validateEmail } from 'client/helpers/Form'
import React, { useState, type CSSProperties, type FormEvent } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import Button from 'src/comps/Atom/Buttons/Button'
import { PENDING, SUBSCRIBED, UNSUBSCRIBED } from 'src/effects/SubscriptionStatus/constants'
import { SubscriptionErrorMsg } from '../SubscriptionErrorMsg'
import { SubscriptionSuccessMsg } from '../SubscriptionSuccessMsg'
import subscriptionStyles from '../styles.module.css'
import styles from './styles.module.css'

interface INewsletterProps {
  readonly status: string
  readonly onSubscribe: (email: string) => void
  readonly bgColor?: string
  readonly variant?: 'section' | 'box' | 'minimal'
  readonly title?: string
  readonly description?: string
  readonly buttonText?: string
  readonly buttonBgColor?: string
  readonly buttonTextColor?: string
}

export function SubscriptionBox(props: INewsletterProps) {
  const {
    status,
    onSubscribe,
    bgColor = '',
    variant = 'section',
    title,
    description,
    buttonText,
    buttonBgColor,
    buttonTextColor,
  } = props

  const isMinimal = variant === 'minimal'
  const [email, setEmail] = useState('')
  const [errors, setErrors] = useState<{ id: string }[]>([])
  const [formSubmitted, setFormSubmitted] = useState(false)
  const intl = useIntl()

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault()

    setFormSubmitted(true)

    if (validateEmail(email)) {
      setErrors([{ id: 'validEmail' }])
      return
    }
    setErrors([])
    onSubscribe(email)
  }

  return (
    <div
      className={styles.base}
      data-variant={variant}
      style={
        {
          '--bg-color': bgColor,
          '--button-bg-color': buttonBgColor,
          '--button-text-color': buttonTextColor,
        } as CSSProperties
      }
      data-testid="subscription-box"
    >
      {(status === SUBSCRIBED || status === PENDING) && <SubscriptionSuccessMsg />}

      {formSubmitted && status === UNSUBSCRIBED && <SubscriptionErrorMsg />}

      {status === UNSUBSCRIBED && (
        <>
          {!isMinimal && (
            <>
              <h5 className={subscriptionStyles.subscriptionBoxTitle}>
                {title || <FormattedMessage id="subscription.subscribe-to-get-unique-discounts" />}
              </h5>
              <p className={subscriptionStyles.subscriptionBoxSubTitle}>
                {description || <FormattedMessage id="subscription.on-our-newsletter" />}
              </p>
            </>
          )}
          <form className={styles.form} onSubmit={handleSubmit}>
            <input
              className={styles.input}
              placeholder={intl.formatMessage({ id: 'global.email' })}
              value={email}
              onChange={e => {
                setEmail(e.target.value)
              }}
            />
            <Button
              className={styles.button}
              size="m"
              type="button"
              onClick={handleSubmit}
              data-custom-bg={!!buttonBgColor}
              data-custom-color={!!buttonTextColor}
            >
              {buttonText || <FormattedMessage id="subscription.subscribe-cta" />}
            </Button>
          </form>
          {errors && <FormErrorMessage errors={errors} />}
        </>
      )}
    </div>
  )
}
